import AcceptInvitationPage from '@/features/login/accept-invitation/[invitationId]/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/login/accept-invitation/$invitationId')({
  component: AcceptInvitationPage,
})
